// extracted by mini-css-extract-plugin
export var addressFields = "_iz-0";
export var animationContainer = "_iz-1";
export var footer = "_iz-2";
export var lineItems = "_iz-3";
export var modalContent = "_iz-4";
export var orderName = "_iz-5";
export var strong = "_iz-6";
export var warning = "_iz-7";